import React, { Component } from 'react'
import { getProperty, weightUnitOptions } from '../../utils'
import {
    formHandler,
    Button,
    Label,
    Select,
    TextInput,
} from '../../ui'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class DroneSelectionForm extends Component {
    constructor(props) {
        super(props)

        const data = { ...props.data }

        const value = getProperty(data, 'max_payload_weight_unit')

        if (! value) {
            if (props.personal.data.country_code === 'US') {
                data.max_payload_weight_unit = 'lb'
            } else {
                data.max_payload_weight_unit = 'kg'
            }
        }

        this.state = { data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    _submitDroneData = () => {
        const data = {
            make: this.state.data.make,
            model: this.state.data.model,
            max_flight_time: this.state.data.max_flight_time,
            max_payload_weight: this.state.data.max_payload_weight,
            max_payload_weight_unit: this.state.data.max_payload_weight_unit,
        }

        this.props.gearActions.submitDrone(
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        const errors = this.props.gear.errors

        return (
            <div>
                <TextInput
                    error={ errors.make }
                    name="make"
                    placeholder="Enter drone make"
                    updateValue={ this._updateValue }
                    value={ this.state.data.make }
                />
                <TextInput
                    error={ errors.model }
                    name="model"
                    placeholder="Enter drone model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
                <TextInput
                    error={ errors.max_flight_time }
                    name="max_flight_time"
                    placeholder="Enter maximum flight time in minutes"
                    type="number"
                    updateValue={ this._updateValue }
                    value={ this.state.data.max_flight_time }
                />

                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <Label inline>Max payload weight:</Label>
                    </div>
                    <div className="grid__span-3">
                        <TextInput
                            error={ errors.max_payload_weight }
                            name="max_payload_weight"
                            type="number"
                            updateValue={ this._updateValue }
                            value={ getProperty(this.state.data, 'max_payload_weight') }
                        />
                    </div>
                    <div className="grid__span-2">
                        <Select
                            error={ errors.max_payload_weight_unit }
                            name="max_payload_weight_unit"
                            options={ weightUnitOptions() }
                            placeholder=""
                            updateValue={ this._updateValue }
                            value={ getProperty(this.state.data, 'max_payload_weight_unit') }
                        />
                    </div>
                </div>

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitDroneData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

DroneSelectionForm.propTypes = {
    appState: React.PropTypes.object,
    crew_uuid: React.PropTypes.string,
    data: React.PropTypes.object,
    gear: React.PropTypes.object,
    gearActions: React.PropTypes.object,
    personal: React.PropTypes.object,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
            personal: state.personal,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(DroneSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/drone_selection_form.js